module.exports = __webpack_public_path__ + "img/option-domain.f1506a19.png";